export const updateSearchInput = (state = {}, {searchInput}: any) => {
  return {
    ...state,
    searchInput,
  };
};
